import { Button, Container, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineOppositeContent, TimelineSeparator } from "@mui/lab";
import * as moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";

export default function TimelinePopup(props) {
    const { t } = useTranslation("translation");

    const timelineColor = (date) => {
        return date === "0001-01-01T00:00:00" ? "secondary" : "primary";
    };

    return (
        <Container id="tp_Container">
            <Dialog id="tp_Dialog" open={props.open} onClose={props.close}>
                <DialogTitle id="tp_DialogTitle">{t("Timeline")}</DialogTitle>
                <DialogContent id="tp_DialogContent">
                    {props.array.map((data, index) => (
                        <Timeline id={`tp_Timeline_${index}`} align="alternate">
                            <TimelineItem id={`tp_TimelineItem_${index}`}>
                                <TimelineOppositeContent id={`tp_TimelineOppositeContent_${index}`}>
                                    <Typography id={`tp_Typography_${index}`} color="textSecondary">
                                        {moment(data.logDate).format("DD.MM.YYYY, HH:mm:ss")}
                                    </Typography>
                                </TimelineOppositeContent>
                                <TimelineSeparator id={`tp_TimelineSeparator_${index}`}>
                                    <TimelineDot id={`tp_TimelineDot_${index}`} color={timelineColor(data.logDate)} />
                                    <TimelineConnector id={`tp_TimelineConnector_${index}`} />
                                </TimelineSeparator>
                                <TimelineContent id={`tp_TimelineContent_${index}`}>
                                    <Typography id={`tp_TimelineContent_1_${index}`}>{data.logText}</Typography>
                                </TimelineContent>
                            </TimelineItem>
                        </Timeline>
                    ))}
                </DialogContent>
                <DialogActions id="tp_DialogActions">
                    <Button id="tp_b" onClick={props.close} color="primary">
                        {t("Close")}
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
}
